import { GET_UDDYAMAAN_PROGRAMS_REQUEST, GET_UDDYAMAAN_PROGRAMS_SUCCESS, GET_UDDYAMAAN_PROGRAMS_FAILURE } from './actionTypes';

const initialState = { programs: [], loading: false, error: false };

const UddyamaanReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_UDDYAMAAN_PROGRAMS_REQUEST: return { ...state, loading: true, error: false };
    case GET_UDDYAMAAN_PROGRAMS_SUCCESS: return { ...state, loading: false, programs: action.payload?.data || [] };
    case GET_UDDYAMAAN_PROGRAMS_FAILURE: return { ...state, loading: false, error: true };
    default: return state;
  }
};

export default UddyamaanReducer;
